import { useQuery } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";
import { IProductCore } from "../types/products";
import { PaginatedResponse } from "../types/core";

const API = process.env.REACT_APP_API;

interface UseCoreProductsParams {
  category?: number;
  producer?: number;
  active?: boolean;
  search?: string;
  ordering?: string;
  page?: number;
  excludeOfferedFair?: number;
}

const useCoreProducts = (params?: UseCoreProductsParams) => {
  const fetch = useFetch();
  const page = params?.page ?? 1;
  const searchTerm = params?.search?.trim();

  return useQuery({
    queryKey: [
      "core-products",
      { ...(params || {}), page, search: searchTerm },
    ],
    queryFn: () => {
      const searchParams = new URLSearchParams();
      searchParams.append("page", page.toString());
      if (params?.category) {
        searchParams.append("category", params.category.toString());
      }
      if (params?.producer) {
        searchParams.append("producer", params.producer.toString());
      }
      if (params?.active !== undefined) {
        searchParams.append("active", params.active.toString());
      }
      if (params?.excludeOfferedFair) {
        searchParams.append(
          "exclude_offered_fair",
          params.excludeOfferedFair.toString(),
        );
      }
      if (searchTerm) {
        searchParams.append("search", searchTerm);
      }
      if (params?.ordering) {
        searchParams.append("ordering", params.ordering);
      }

      const queryString = searchParams.toString();
      const url = `${API}/api/semeadora/core_products/${queryString ? `?${queryString}` : ""}`;

      return fetch(url, {
        method: "GET",
      }) as Promise<PaginatedResponse<IProductCore>>;
    },
    keepPreviousData: true,
    onError: (error) => {
      console.error("Erro ao buscar core_products", error);
    },
  });
};

export default useCoreProducts;
